import React from "react";
import PropTypes from "prop-types";

const JobAppliedSuccessModal = ({
  isOpen,
  setIsOpen,
  setIsOpenFeedbackModal,
}) => {
  if (!isOpen) return null;

  return (
    <div
      className="modal fade show d-block"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="jobAppliedSuccessModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="jobAppliedSuccessModalLabel">
              Application Submitted!
            </h5>
            <button
              type="button"
              className="close"
              onClick={() => {
                setIsOpen(false);
              }}
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            Your job application has been successfully submitted. Would you like
            to provide feedback?
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => setIsOpen(false)}
            >
              No Thanks!
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => {
                setIsOpenFeedbackModal(true);
                setIsOpen(false);
              }}
            >
              Feedback
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

JobAppliedSuccessModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onFeedback: PropTypes.func.isRequired,
};

export default JobAppliedSuccessModal;
